import { useState, useEffect } from 'react';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import { FaEye, FaPhoneAlt, FaPen } from 'react-icons/fa';
import { profileApi } from '../../api/profile.api';
import {
  FaEnvelope,
  FaUser,
  FaLock,
  FaEyeSlash,
} from 'react-icons/fa';
import { profileSchema, passwordPasswordchema } from '../../../../schemas/profileSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import PasswordRules from '../../../../components/GenericComponents/PasswordRules';
import {
  TOAST_SUCCESS_IDS,
  TOAST_ERROR_IDS,
  TOAST_INFO_IDS,
} from '../../../../interaces/toast.ids.interface';
import styles from "../../styles/styles.module.css"
function MyProfile() {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(profileSchema),
  });
  const {
    register: registerPassword,
    watch: watchPassword,
    handleSubmit: handleSubmitPassword,
    formState: { errors: errorsPassword },
    reset: resetPassword,
  } = useForm({
    resolver: zodResolver(passwordPasswordchema),
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmationNewPassword, setShowConfirmationNewPassword] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [savingProfile, setSavingProfile] = useState(false);
  const [savingPassword, setSavingPassword] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const loadProfile = async () => {
    try {
      const data = await profileApi.getMe();
      setProfile(data);
      reset({
        email: data.email || '',
        phone: data.phone || '',
      });
    } catch (error) {
      toast.error('Error al cargar el perfil');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const handleSavePassword = async (data) => {
    setSavingPassword(true);
    try {
      await profileApi.changePassword(data);
      toast.success(TOAST_SUCCESS_IDS.PASSWORD_UPDATED_CORRECTLY, {
        id: TOAST_SUCCESS_IDS.PASSWORD_UPDATED_CORRECTLY,
      });
      resetPassword();
      setIsEditingPassword(false);
    } catch (error) {
      console.log(error)
      toast.error('Error al actualizar tu contraseña, porfavor verifica que los datos ingresados sean correctos' || TOAST_ERROR_IDS.ERROR_CHANGING_THE_PASSWORD, {
        id: TOAST_ERROR_IDS.ERROR_CHANGING_THE_PASSWORD,
      });
    } finally {
      setSavingPassword(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="profile-page">Cargando perfil...</div>
      </DashboardLayout>
    );
  }

  const onSubmit = async (data) => {
    if (
      profile.email == data.email &&
      profile.phone == data.phone &&
      (!data.curp || data.curp == profile.curp)
    ) {
      toast(TOAST_INFO_IDS.NO_UPDATE_DATA, {
        icon: 'ℹ️',
        id: TOAST_INFO_IDS.NO_UPDATE_DATA,
      });
      return;
    }
    if (profile.email == data.email) {
      delete data.email;
    }
    if (profile.phone == data.phone) {
      delete data.phone;
    }
    if (!data.curp || data.curp == profile.curp) {
      delete data.curp;
    }

    setSavingProfile(true);
    try {
      await profileApi.updateMe(data);
      toast.success('Perfil actualizado exitosamente');
      await loadProfile();
      setIsEditingContact(false);
    } catch (error) {
      toast.error(
        (error.message && error.message != 'Error'
          ? error.message
          : TOAST_ERROR_IDS.ERROR_TO_PERFORMING_THIS_ACTION) ||
          TOAST_ERROR_IDS.ERROR_TO_PERFORMING_THIS_ACTION,
        { id: TOAST_ERROR_IDS.ERROR_TO_PERFORMING_THIS_ACTION }
      );
    } finally {
      setSavingProfile(false);
    }
  };
  return (
    <DashboardLayout>
      <div className={styles.pageContainerMyprofile}>
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Consulta y actualiza la información de tu cuenta.</p>
          </div>
        </div>

        <div className={styles.divInformation}>
          {/* Información Personal */}
          <div className={'card-base w-full'}>
            <div className={styles.cardHeaderMiprofile }>
              <h3 className={styles.ardTitleMyProfile}>Información Personal</h3>
              <p className={styles.cardSubtitleMyProfile}>Datos personales registrados</p>
            </div>

            <div className={styles.fieldsGridMyProfile }>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>CURP</span>
                <span className={styles.fieldValueMyProfile}>{profile.curp || '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>RFC</span>
                <span className={styles.fieldValueMyProfile}>{profile.rfc || '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Nombre(s)</span>
                <span className={styles.fieldValueMyProfile}>{profile.name || '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Primer apellido</span>
                <span className={styles.fieldValueMyProfile}>{profile.firstLastName|| '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Segundo apellido</span>
                <span className={styles.fieldValueMyProfile}>{profile.secondLastName|| '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Sexo</span>
                <span className={styles.fieldValueMyProfile}>
                  {profile.gender === 'H'
                    ? 'HOMBRE'
                    : profile.gender === 'M'
                      ? 'MUJER'
                      : profile.gender || '—'}
                </span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Fecha de nacimiento</span>
                <span className={styles.fieldValueMyProfile}>{profile.birthDate || '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Nacionalidad</span>
                <span className={styles.fieldValueMyProfile}>{profile.nationality || '—'}</span>
              </div>
              <div className={styles.fieldMyProfile }>
                <span className={styles.fieldLabelMyProfile}>Entidad de nacimiento</span>
                <span className={styles.fieldValueMyProfile}>{profile.birthPlace || '—'}</span>
              </div>
            </div>
          </div>

          {/* Datos de contacto */}
          <div className="card-base mt-4">
            <div className={styles.profileSectionHeader}>
              <h3 className={styles.profilecardTitle }>Datos de contacto</h3>
              <button
                type="button"
                className={styles.profileEditButton}
                aria-label={isEditingContact ? 'Cancelar edición de datos de contacto' : 'Editar datos de contacto'}
                aria-pressed={isEditingContact}
                title={isEditingContact ? 'Cancelar edición' : 'Editar datos de contacto'}
                disabled={savingProfile}
                onClick={() => {
                  if (isEditingContact) {
                    reset({ email: profile.email, phone: profile.phone, curp: profile.curp });
                  }
                  setIsEditingContact((editing) => !editing);
                }}
              >
                <FaPen aria-hidden="true" />
              </button>
            </div>

            {message.text && (
              <div
                className={`${styles.profileAlertBanner }${message.type === 'success' ? styles.alertSuccess : styles.alertError}`}
              >
                {message.text}
              </div>
            )}

            <form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-div-columns">
                {/* Correo */}
                <div className={styles.formGroup}>
                  <div className={styles.formLabelRow }>
                    <FaEnvelope />
                    <span>Correo</span>
                  </div>
                  <input
                    type="email"
                    name="email"
                    disabled={!isEditingContact || savingProfile}
                    {...register('email', {
                      onChange: (e) => {
                        e.target.value = e.target.value.toUpperCase();
                      },
                    })}
                    className="input-base"
                  />
                  {errors.email && <span className="error-text">{errors.email.message}</span>}
                </div>

                {/* Teléfono */}
                <div className={styles.formGroup}>
                  <div className={styles.formLabelRow }>
                    <FaPhoneAlt />
                    <span>Teléfono</span>
                  </div>
                  <input
                    type="text"
                    name="phone"
                    maxLength="10"
                    disabled={!isEditingContact || savingProfile}
                    {...register('phone', {
                      onChange: (e) => {
                        e.target.value = e.target.value.replace(/\D/g, '');
                      },
                    })}
                    className="input-base"
                  />
                  {errors.phone && <span className="error-text">{errors.phone.message}</span>}
                </div>

               
              </div>

              {isEditingContact && (
                <div className="modal-footer">
                  <button type="submit" className="btn-primary" disabled={savingProfile}>
                    {savingProfile ? 'Guardando...' : 'Guardar Cambios'}
                  </button>
                </div>
              )}
            </form>
          </div>

          {/* Seguridad */}
          <div className={`card-base ${styles.profileSectionSecurity}`}>
            <div className={styles.sectionHeaderMyProfile}>
              <h3 className={styles.profileCardTitleIcon}>
                <FaLock />
                Seguridad
              </h3>
              <button
                type="button"
                className={styles.profileEditButton }
                aria-label={isEditingPassword ? 'Cancelar cambio de contraseña' : 'Editar contraseña'}
                aria-pressed={isEditingPassword}
                title={isEditingPassword ? 'Cancelar cambio' : 'Editar contraseña'}
                disabled={savingPassword}
                onClick={() => {
                  if (isEditingPassword) resetPassword();
                  setIsEditingPassword((editing) => !editing);
                }}
              >
                <FaPen aria-hidden="true" />
              </button>
            </div>

            <form onSubmit={handleSubmitPassword(handleSavePassword)}>
              <div className={styles.fieldsGrid3}>
                {/* Contraseña actual */}
                <div className="w-full ">
                  <label htmlFor="currentPassword" className={styles.profileFormLabel}>
                    Contraseña actual
                  </label>
                  <div className={styles.relativeWrapper}>
                    <input
                      id="currentPassword"
                      type={showCurrentPassword ? 'text' : 'password'}
                      name="currentPassword"
                      placeholder="Ingresa tu contraseña actual"
                      disabled={!isEditingPassword || savingPassword}
                      {...registerPassword('currentPassword')}
                      className="input-base"
                    />
                    <button
                      type="button"
                      onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                      aria-label={showCurrentPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                      className={styles.passwordToggle}
                      disabled={!isEditingPassword || savingPassword}
                    >
                      {showCurrentPassword ? (
                        <FaEyeSlash className={styles.iconFaEyeSlash}size={17} />
                      ) : (
                        <FaEye size={17} />
                      )}
                    </button>
                  </div>
                  {errorsPassword.currentPassword && (
                    <span className="error-text">
                      {errorsPassword.currentPassword.message}
                    </span>
                  )}
                </div>

                {/* Nueva contraseña */}
                <div className="w-full">
                  <label htmlFor="newPassword" className={styles.profileFormLabel}>
                    Nueva contraseña
                  </label>
                  <div className={styles.relativeWrapper}>
                    <input
                      id="newPassword"
                      type={showNewPassword ? 'text' : 'password'}
                      name="newPassword"
                      placeholder="Ingresa tu nueva contraseña"
                      disabled={!isEditingPassword || savingPassword}
                      {...registerPassword('newPassword')}
                      className="input-base"
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      aria-label={showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                      className={styles.passwordToggle}
                      disabled={!isEditingPassword || savingPassword}
                    >
                      {showNewPassword ? (
                        <FaEyeSlash className={styles.iconFaEyeSlash} size={17} />
                      ) : (
                        <FaEye size={17} />
                      )}
                    </button>
                  </div>
                  {errorsPassword.newPassword && !errorsPassword.currentPassword && (
                    <span className="error-text">{errorsPassword.newPassword.message}</span>
                  )}
                  {watchPassword('newPassword') && (
                    <PasswordRules
                      password={watchPassword('newPassword')}
                      message="La nueva contraseña "
                    />
                  )}
                </div>

                {/* Confirmar contraseña */}
                <div className="div-full">
                  <label htmlFor="ConfirmationNewPassword" className={styles.profileFormLabel}>
                    Confirma tu nueva contraseña
                  </label>
                  <div className={styles.relativeWrapper}>
                    <input
                      id="confirmPassword"
                      type={showConfirmationNewPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      placeholder="Ingresa la confirmación de tu contraseña"
                      disabled={!isEditingPassword || savingPassword}
                      {...registerPassword('confirmPassword')}
                      className="input-base"
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmationNewPassword(!showConfirmationNewPassword)}
                      aria-label={
                        showConfirmationNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
                      }
                      className={styles.passwordToggle}
                      disabled={!isEditingPassword || savingPassword}
                    >
                      {showConfirmationNewPassword ? (
                        <FaEyeSlash className={styles.iconFaEyeSlash} size={17} />
                      ) : (
                        <FaEye size={17} />
                      )}
                    </button>
                  </div>
                  {errorsPassword.confirmPassword &&
                    !errorsPassword.currentPassword &&
                    !errorsPassword.newPassword && (
                      <span className="error-text">
                        {errorsPassword.confirmPassword.message}
                      </span>
                    )}
                  {watchPassword('confirmPassword') && (
                    <PasswordRules
                      password={watchPassword('confirmPassword')}
                      message="La confirmación de la nueva contraseña "
                    />
                  )}
                </div>
              </div>
              {isEditingPassword && (
                <div className="modal-footer">
                  <button className="btn-primary" disabled={savingPassword} type="submit">
                    {savingPassword ? 'Cambiando...' : 'Cambiar Contraseña'}
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default MyProfile;
